import React, { Component } from "react";
import { ActionIDs } from "../../../GenericWebController/ActionGraph/ActionIDs/ActionIDs";
import Actions from "../../../GenericWebController/ActionGraph/Actions";
import {
  DebugAlert,
  Class,
  Interface,
  Abstract,
  ObjectTypes,
  JSTypeOperator,
  cListForBase,
} from "../../../GenericCoreGraph/ClassFramework/Class";
import TObject from "../../../TagComponents/TObject";
import GenericWebGraph from "../../../GenericWebController/GenericWebGraph";
import { CommandInterfaces } from "../../../GenericWebController/CommandInterpreter/cCommandInterpreter";
import { CommandIDs } from "../../../GenericWebController/CommandInterpreter/CommandIDs/CommandIDs";

import { withStyles } from "@material-ui/core/styles";
import BigCalendarStyles from "../../../../ScriptStyles/BigCalendarStyles";
import classNames from "classnames";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import { Avatar } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import DefaultTheme from "../../../../Themes/DefaultTheme";
import TAvatar from "../BasicComponent/TAvatar";

var TBigCalenderItem = Class(
  TObject,

  {
    ObjectType: ObjectTypes.Get("TBigCalenderItem"),
    constructor: function (_Props) {
      TBigCalenderItem.BaseObject.constructor.call(this, _Props);
      this.state = {
        ...this.state,
        cellstate: _Props.cellstate,
        hover: false,
        ReservationObject: null,
      };
      var __This = this;
      var __Item = this.props.owner.ItemList.find(function (_Item) {
        return _Item.ReactItem.key == __This.props.mykey;
      });

      __Item.Instance = this;
      this.AvailableTimeItemList = [];
    },
    Destroy: function () {
      TBigCalenderItem.BaseObject.Destroy.call(this);
    },
    HandleGetCellState: function () {
      return this.state.cellstate;
    },
    HandleIsStateThat: function (_CellState) {
      return this.state.cellstate == _CellState;
    },
    HandleClear: function () {
      this.AvailableTimeItemList = [];
      this.setState({
        cellstate: window.Enums.EBigCalenderCellState.NotSelected,
        hover: false,
        ReservationObject: null,
      });
    },
    HandleSetCellStateDirect_Unsafe: function (_State) {
      this.setState({
        cellstate: _State,
      });
    },
    HandleGetSelectedItemObject(_CellState) {
      const __DiffDays = Math.ceil(
        (this.props.daydate - this.props.owner.HandleGetStartDate()) /
          (1000 * 60 * 60 * 24)
      );

      return {
        Day: __DiffDays,
        StartHour: this.props.blockstarthour,
        StartMinute: this.props.blockstartminute,
        EndHour: this.props.blockendhour,
        EndMinute: this.props.blockendminute,
      };
    },
    HandleBookedIDIsEqual_CustomerBookedScheduler: function (_BookedID) {
      if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        if (this.AvailableTimeItemList.length > 0) {
          if (this.AvailableTimeItemList[0].BookedID == _BookedID) {
            return true;
          }
        }
      }
      return false;
    },
    HandleBookedIDIsEqual_SellerBookedScheduler: function (_BookedID) {
      if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        if (this.AvailableTimeItemList.length > 0) {
          if (this.AvailableTimeItemList[0].BookedID == _BookedID) {
            return true;
          }
        }
      }
      return false;
    },
    //////////////////////////////////////////////////////////////////
    /////////////////  Ders verilerinin ilk hücerei olup olmadığı kontrolleri
    //////////////////////////////////////////////////////////////////
    HandleIsLessonStartCell_SellerBookedScheduler: function () {
      if (this.AvailableTimeItemList.length > 0) {
        var __StartCell = this.props.owner.HandleGetLessonStartCell(this);
        return __StartCell == this;
      } else {
        return false;
      }
    },
    HandleIsLessonStartCell_CustomerBookedScheduler: function () {
      if (this.AvailableTimeItemList.length > 0) {
        var __StartCell = this.props.owner.HandleGetLessonStartCell(this);
        return __StartCell == this;
      } else {
        return false;
      }
    },
    HandleIsLessonStartCell: function () {
      if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        return this.HandleIsLessonStartCell_SellerBookedScheduler();
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        return this.HandleIsLessonStartCell_CustomerBookedScheduler();
      }
      return true;
    },
    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////
    /////////////////  Dersin kendinden sonra bağlı dersin olup olmadığı kontrolleri
    //////////////////////////////////////////////////////////////////
    HandleHaveNextLesson_SellerBookedScheduler: function () {
      if (this.AvailableTimeItemList.length > 0) {
        var __StartCellList =
          this.props.owner.HandleGetCellItemListByBooked_SellerBookedScheduler(
            this.AvailableTimeItemList[0].BookedID
          );
        for (var i = 0; i < __StartCellList.length; i++) {
          if (
            __StartCellList[i] != this &&
            __StartCellList[i].AvailableTimeItemList.length > 0
          ) {
            if (
              __StartCellList[i].AvailableTimeItemList[0].StartTotalMinute >
              this.AvailableTimeItemList[0].StartTotalMinute
            ) {
              return true;
            }
          }
        }
        return false;
      } else {
        return false;
      }
    },
    HandleHaveNextLesson_CustomerBookedScheduler: function () {
      if (this.AvailableTimeItemList.length > 0) {
        var __StartCellList =
          this.props.owner.HandleGetCellItemListByBooked_CustomerBookedScheduler(
            this.AvailableTimeItemList[0].BookedID
          );
        for (var i = 0; i < __StartCellList.length; i++) {
          if (
            __StartCellList[i] != this &&
            __StartCellList[i].AvailableTimeItemList.length > 0
          ) {
            if (
              __StartCellList[i].AvailableTimeItemList[0].StartTotalMinute >
              this.AvailableTimeItemList[0].StartTotalMinute
            ) {
              return true;
            }
          }
        }
        return false;
      } else {
        return false;
      }
    },
    HandleHaveNextLesson: function () {
      if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        return this.HandleHaveNextLesson_SellerBookedScheduler();
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        return this.HandleHaveNextLesson_CustomerBookedScheduler();
      }
      return false;
    },
    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    /////////////////  Hücre içine Item ve itemlar setlenebilir
    /////////////////  Gönderilen item ve içeriğine göre hücrenin durumu belirlenir.
    //////////////////////////////////////////////////////////////////
    HandleSetTimeItem_AvailableTimeSelection: function (_TimeItem) {
      /*this.setState({
        cellstate: window.Enums.EBigCalenderCellState.SelectedFromSeller
      });*/

      if (_TimeItem.ClassLessonTime) {
        this.setState({
          cellstate: window.Enums.EBigCalenderCellState.GroupCell,
        });
      } else if (_TimeItem.IsOtherClassLesson) {
        this.setState({
          cellstate: window.Enums.EBigCalenderCellState.BookedGroupByYou,
        });
      } else if (_TimeItem.IsBooked) {
        this.setState({
          cellstate: window.Enums.EBigCalenderCellState.BookedByOther,
        });
      } else {
        this.setState({
          cellstate: window.Enums.EBigCalenderCellState.SelectedFromSeller,
        });
      }
    },
    HandleSetTimeItem_MiniAvailableTimeShow: function (_TimeItem) {
      this.AvailableTimeItemList.push(_TimeItem);

      var __FreeTimeCount = 0;
      var __BussyTimeCount = 0;

      if (this.props.owner.props.isGroupLesson) {
        for (var i = 0; i < this.AvailableTimeItemList.length; i++) {
          if (
            this.AvailableTimeItemList[i].BookedCount <
            this.AvailableTimeItemList[i].MaxBookingCount
          ) {
            __FreeTimeCount++;
          } else {
            __BussyTimeCount++;
          }
        }

        if (__FreeTimeCount == 0) {
          this.setState({
            cellstate: window.Enums.EBigCalenderCellState.GroupCellFull,
          });
        } else {
          this.setState({
            cellstate:
              window.Enums.EBigCalenderCellState
                .SelectableGroupCellFromCustomer,
          });
        }
      } else {
        for (var i = 0; i < this.AvailableTimeItemList.length; i++) {
          if (this.AvailableTimeItemList[i].IsBooked) {
            __BussyTimeCount++;
          } else {
            __FreeTimeCount++;
          }
        }

        if (__FreeTimeCount == 0) {
          this.setState({
            cellstate: window.Enums.EBigCalenderCellState.BookedByOther,
          });
        } else {
          this.setState({
            cellstate:
              window.Enums.EBigCalenderCellState
                .SelectableIndividualCellFromCustomer,
          });
        }
      }
    },
    HandleSetTimeItem_CustomerAvailableBookSelection: function (_TimeItem) {
      this.AvailableTimeItemList.push(_TimeItem);

      if (
        this.props.type ==
        window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        if (
          !_TimeItem.IsBookedFromYou &&
          _TimeItem.BookedCount < _TimeItem.MaxBookingCount
        ) {
          this.setState({
            cellstate:
              window.Enums.EBigCalenderCellState
                .SelectableGroupCellFromCustomer,
          });
        } else if (_TimeItem.IsBookedFromYou) {
          this.setState({
            cellstate: window.Enums.EBigCalenderCellState.BookedGroupByYou,
          });
        } else if (_TimeItem.BookedCount >= _TimeItem.MaxBookingCount) {
          this.setState({
            cellstate: window.Enums.EBigCalenderCellState.GroupCellFull,
          });
        }
      } else {
        if (!_TimeItem.IsBooked) {
          this.setState({
            cellstate:
              window.Enums.EBigCalenderCellState
                .SelectableIndividualCellFromCustomer,
          });
        } else if (_TimeItem.IsBookedFromYou) {
          this.setState({
            cellstate: window.Enums.EBigCalenderCellState.BookedByYou,
          });
        } else if (_TimeItem.IsBooked && !_TimeItem.IsBookedFromYou) {
          this.setState({
            cellstate: window.Enums.EBigCalenderCellState.BookedByOther,
          });
        }
      }
    },
    HandleSetTimeItem_ClassTimeSelection: function (_TimeItem) {
      if (_TimeItem.ClassLessonTime) {
        this.setState({
          cellstate: window.Enums.EBigCalenderCellState.GroupCell,
        });
      } else if (_TimeItem.IsOtherClassLesson) {
        this.setState({
          cellstate: window.Enums.EBigCalenderCellState.BookedGroupByYou,
        });
      } else if (_TimeItem.IsBooked) {
        this.setState({
          cellstate: window.Enums.EBigCalenderCellState.BookedByOther,
        });
      } else {
        this.setState({
          cellstate: window.Enums.EBigCalenderCellState.SelectedFromSeller,
        });
      }
    },
    HandleSetTimeItem_SellerBookedScheduler: function (_TimeItem) {
      this.AvailableTimeItemList.push(_TimeItem);
      if (_TimeItem.LessonType == window.Enums.ELessonType.Class.ID) {
        this.setState({
          cellstate:
            window.Enums.EBigCalenderCellState.GroupCell_ForSellerBookedView,
        });
      } else if (
        _TimeItem.LessonType == window.Enums.ELessonType.Individual.ID
      ) {
        this.setState({
          cellstate:
            window.Enums.EBigCalenderCellState
              .IndividualCell_ForBookedSellerView,
        });
      }
    },
    HandleSetTimeItem_CustomerBookedScheduler: function (_TimeItem) {
      this.AvailableTimeItemList.push(_TimeItem);
      if (_TimeItem.LessonType == window.Enums.ELessonType.Class.ID) {
        this.setState({
          cellstate:
            window.Enums.EBigCalenderCellState.GroupCell_ForCustomerBookedView,
        });
      } else if (
        _TimeItem.LessonType == window.Enums.ELessonType.Individual.ID
      ) {
        this.setState({
          cellstate:
            window.Enums.EBigCalenderCellState
              .IndividualCell_ForCustomerBookedView,
        });
      }
    },
    HandleSetTimeItem: function (_TimeItem) {
      if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        this.HandleSetTimeItem_AvailableTimeSelection(_TimeItem);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        this.HandleSetTimeItem_MiniAvailableTimeShow(_TimeItem);
      } else if (
        this.props.type ==
          window.Enums.EBigCalenderType
            .CustomerAvailableBookSelection_Individual ||
        this.props.type ==
          window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        this.HandleSetTimeItem_CustomerAvailableBookSelection(_TimeItem);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection
      ) {
        this.HandleSetTimeItem_ClassTimeSelection(_TimeItem);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        this.HandleSetTimeItem_SellerBookedScheduler(_TimeItem);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        this.HandleSetTimeItem_CustomerBookedScheduler(_TimeItem);
      }
    },

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////
    ///////////////////////Hücre özelliği, Hücre border ları ile ilgili olanlar
    //////////////////////////////////////////////////////////////////
    HandleGetBoxProps_MiniAvailableTimeShow: function () {
      const { classes } = this.props;

      if (this.props.right && this.props.bottom) {
        return classes.miniDayBoxBottomRight;
      } else if (this.props.right) {
        return classes.miniDayBoxRight;
      } else if (this.props.bottom) {
        return classes.miniDayBoxBottom;
      }
      return classes.miniDayBox;
    },
    HandleGetBoxProps_SellerBookedScheduler: function () {
      const { classes } = this.props;

      if (this.HandleHaveNextLesson()) {
        if (this.props.right && this.props.bottom) {
          return classes.dayBoxBottomRight;
        } else if (this.props.right) {
          return classes.dayBoxRightMerged;
        } else if (this.props.bottom) {
          return classes.dayBoxBottom;
        }
        return classes.dayBoxMerged;
      } else {
        if (this.props.right && this.props.bottom) {
          return classes.dayBoxBottomRight;
        } else if (this.props.right) {
          return classes.dayBoxRight;
        } else if (this.props.bottom) {
          return classes.dayBoxBottom;
        }
        return classes.dayBox;
      }
    },
    HandleGetBoxProps_CustomerBookedScheduler: function () {
      const { classes } = this.props;

      if (this.HandleHaveNextLesson()) {
        if (this.props.right && this.props.bottom) {
          return classes.dayBoxBottomRight;
        } else if (this.props.right) {
          return classes.dayBoxRightMerged;
        } else if (this.props.bottom) {
          return classes.dayBoxBottom;
        }
        return classes.dayBoxMerged;
      } else {
        if (this.props.right && this.props.bottom) {
          return classes.dayBoxBottomRight;
        } else if (this.props.right) {
          return classes.dayBoxRight;
        } else if (this.props.bottom) {
          return classes.dayBoxBottom;
        }
        return classes.dayBox;
      }
    },
    HandleGetBoxProps: function () {
      const { classes } = this.props;
      if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return this.HandleGetBoxProps_MiniAvailableTimeShow();
      } else if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        return this.HandleGetBoxProps_SellerBookedScheduler();
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        return this.HandleGetBoxProps_CustomerBookedScheduler();
      } else {
        if (this.props.right && this.props.bottom) {
          return classes.dayBoxBottomRight;
        } else if (this.props.right) {
          return classes.dayBoxRight;
        } else if (this.props.bottom) {
          return classes.dayBoxBottom;
        }
        return classes.dayBox;
      }
    },
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    HandleOnMouseEnterHandler: function () {
      if (
        this.props.type ==
          window.Enums.EBigCalenderType
            .CustomerAvailableBookSelection_Individual ||
        this.props.type ==
          window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        var __Constrained = this.props.owner.HandleGetCellCanSelectable(this);
        if (
          this.props.owner &&
          !this.props.owner.props.locked &&
          __Constrained.CanSelectable
        ) {
          this.Constrained = __Constrained;
          this.setState({ hover: true });
          for (var i = 0; i < this.Constrained.ItemList.length; i++) {
            this.Constrained.ItemList[i].setState({ hover: true });
          }
        }
      } else if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        var __Constrained = this.props.owner.HandleGetCellCanSelectable(this);
        if (
          this.props.owner &&
          !this.props.owner.props.locked &&
          __Constrained.CanSelectable
        ) {
          this.Constrained = __Constrained;
          this.setState({ hover: true });
          for (var i = 0; i < this.Constrained.ItemList.length; i++) {
            this.Constrained.ItemList[i].setState({ hover: true });
          }
        }
        /*if (this.props.owner && !this.props.owner.props.locked && this.props.owner.HandleGetCellCanSelectable(this))
        {
          this.setState({ hover: true })
        };*/
      } else {
        if (
          this.props.owner &&
          !this.props.owner.props.locked &&
          this.props.owner.HandleGetCellCanSelectable(this)
        ) {
          this.setState({ hover: true });
        }
      }
    },
    HandleOnMouseLeave: function () {
      if (
        this.props.type ==
          window.Enums.EBigCalenderType
            .CustomerAvailableBookSelection_Individual ||
        this.props.type ==
          window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        this.setState({ hover: false });
        if (this.Constrained != null) {
          for (var i = 0; i < this.Constrained.ItemList.length; i++) {
            this.Constrained.ItemList[i].setState({ hover: false });
          }
          this.Constrained = null;
        }
      } else if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        this.setState({ hover: false });
        if (this.Constrained != null) {
          for (var i = 0; i < this.Constrained.ItemList.length; i++) {
            this.Constrained.ItemList[i].setState({ hover: false });
          }
          this.Constrained = null;
        }
      } else {
        if (!this.props.owner.props.locked) {
          this.setState({ hover: false });
        }
      }
    },
    //////////////////////////////////////////////////////////////////
    /////////////////  Hücre durumuuna göre stil belirleme ////////////
    //////////////////////////////////////////////////////////////////
    HandleGetBoxState_NotSelected: function () {
      const { classes } = this.props;

      return classes.notSelected;
    },
    HandleGetBoxState_SelectedFromSeller: function () {
      const { classes } = this.props;

      if (this.state.hover) {
        return classNames(classes.availableBlock, classes.hoverBlock);
      } else {
        return classes.availableBlock;
      }
    },
    HandleGetBoxState_SelectableIndividualCellFromCustomer: function () {
      const { classes } = this.props;

      if (this.state.hover) {
        return classNames(
          classes.selectableIndividualBlock,
          classes.hoverBlock
        );
      } else {
        return classes.selectableIndividualBlock;
      }
    },
    HandleGetBoxState_BookedByYou: function () {
      const { classes } = this.props;

      return classNames(classes.individualBookedByYou);
    },
    HandleGetBoxState_BookedByOther: function () {
      const { classes } = this.props;

      return classNames(classes.individualBookedBlock);
    },
    HandleGetBoxState_BookedGroupByYou: function () {
      const { classes } = this.props;

      return classNames(classes.groupBookedByYou);
    },
    HandleGetBoxState_SelectableGroupCellFromCustomer: function () {
      const { classes } = this.props;

      if (this.state.hover) {
        return classNames(classes.selectableGroupBlock, classes.hoverBlock);
      } else {
        return classes.selectableGroupBlock;
      }
    },
    HandleGetBoxState_GroupCellFull: function () {
      const { classes } = this.props;

      return classNames(classes.fullGroupBlock);
    },
    HandleGetBoxState_GroupCell: function () {
      const { classes } = this.props;

      if (this.state.hover) {
        return classNames(classes.classBlock, classes.hoverBlock);
      } else {
        return classes.classBlock;
      }
    },
    HandleGetBoxState_SelectedFromCustomer: function () {
      const { classes } = this.props;

      if (this.state.hover) {
        return classNames(classes.selectedFromCustomer, classes.hoverBlock);
      } else {
        return classes.selectedFromCustomer;
      }
    },
    HandleGetBoxState_AvailableTimeSelection: function () {
      const { classes } = this.props;

      if (this.state.hover) {
        return classNames(classes.redHoverBlock, classes.hoverBlock);
      }
    },
    HandleGetBoxState_GroupCell_ForSellerBookedView: function () {
      const { classes } = this.props;

      return classNames(classes.groupCell_ForBookedView);
    },
    IndividualCell_ForBookedSellerView: function () {
      const { classes } = this.props;

      return classNames(classes.individualCell_ForBookedView);
    },
    HandleGetBoxState_GroupCell_ForCustomerBookedView: function () {
      const { classes } = this.props;

      return classNames(classes.groupCell_ForBookedView);
    },
    IndividualCell_ForBookedCustomerView: function () {
      const { classes } = this.props;

      return classNames(classes.individualCell_ForBookedView);
    },
    HandleGetBoxState: function () {
      if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.SelectedFromSeller
      ) {
        return this.HandleGetBoxState_SelectedFromSeller();
      } else if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.SelectableIndividualCellFromCustomer
      ) {
        return this.HandleGetBoxState_SelectableIndividualCellFromCustomer();
      } else if (
        this.state.cellstate == window.Enums.EBigCalenderCellState.BookedByYou
      ) {
        return this.HandleGetBoxState_BookedByYou();
      } else if (
        this.state.cellstate == window.Enums.EBigCalenderCellState.BookedByOther
      ) {
        return this.HandleGetBoxState_BookedByOther();
      } else if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.BookedGroupByYou
      ) {
        return this.HandleGetBoxState_BookedGroupByYou();
      } else if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.SelectableGroupCellFromCustomer
      ) {
        return this.HandleGetBoxState_SelectableGroupCellFromCustomer();
      } else if (
        this.state.cellstate == window.Enums.EBigCalenderCellState.GroupCellFull
      ) {
        return this.HandleGetBoxState_GroupCellFull();
      } else if (
        this.state.cellstate == window.Enums.EBigCalenderCellState.GroupCell
      ) {
        return this.HandleGetBoxState_GroupCell();
      } else if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.SelectedFromCustomer
      ) {
        return this.HandleGetBoxState_SelectedFromCustomer();
      } else if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        return this.HandleGetBoxState_AvailableTimeSelection();
      } else if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.GroupCell_ForSellerBookedView
      ) {
        return this.HandleGetBoxState_GroupCell_ForSellerBookedView();
      } else if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.IndividualCell_ForBookedSellerView
      ) {
        return this.IndividualCell_ForBookedSellerView();
      } else if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.GroupCell_ForCustomerBookedView
      ) {
        return this.HandleGetBoxState_GroupCell_ForCustomerBookedView();
      } else if (
        this.state.cellstate ==
        window.Enums.EBigCalenderCellState.IndividualCell_ForBookedCustomerView
      ) {
        return this.IndividualCell_ForBookedCustomerView();
      }
      return this.HandleGetBoxState_NotSelected();
    },
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////
    /////////////////  Hücre Tıklama  Olayı///////////////////////////
    //////////////////////////////////////////////////////////////////

    HandleCellOnClick_ClassTimeSelection: function (_Event) {
      if (
        !this.props.locked &&
        this.state.hover &&
        (this.state.cellstate ==
          window.Enums.EBigCalenderCellState.SelectedFromSeller ||
          this.state.cellstate == window.Enums.EBigCalenderCellState.GroupCell)
      ) {
        this.setState({
          cellstate:
            this.state.cellstate ==
            window.Enums.EBigCalenderCellState.SelectedFromSeller
              ? window.Enums.EBigCalenderCellState.GroupCell
              : window.Enums.EBigCalenderCellState.SelectedFromSeller,
        });
      }
    },
    HandleCellOnClick_AvailableTimeSelection: function (_Event) {
      if (
        !this.props.locked &&
        this.state.hover &&
        (this.state.cellstate ==
          window.Enums.EBigCalenderCellState.SelectedFromSeller ||
          this.state.cellstate ==
            window.Enums.EBigCalenderCellState.NotSelected)
      ) {
        var __CellState =
          this.state.cellstate == window.Enums.EBigCalenderCellState.NotSelected
            ? window.Enums.EBigCalenderCellState.SelectedFromSeller
            : window.Enums.EBigCalenderCellState.NotSelected;

        this.setState({
          cellstate: __CellState,
        });

        if (this.Constrained != null) {
          for (var i = 0; i < this.Constrained.ItemList.length; i++) {
            this.Constrained.ItemList[i].setState({
              cellstate: __CellState,
            });
          }
        }
      }
    },
    HandleCellOnClick_MiniAvailableTimeShow: function (_Event) {
      if (!this.props.locked && this.state.hover) {
        this.setState({
          cellstate:
            this.state.cellstate ==
            window.Enums.EBigCalenderCellState.NotSelected
              ? window.Enums.EBigCalenderCellState.SelectedFromSeller
              : window.Enums.EBigCalenderCellState.NotSelected,
        });
      }
    },
    HandleCellOnClick_CustomerAvailableBookSelection_Individual: function (
      _Event
    ) {
      if (
        !this.props.locked &&
        this.state.hover &&
        (this.state.cellstate ==
          window.Enums.EBigCalenderCellState.SelectedFromCustomer ||
          this.state.cellstate ==
            window.Enums.EBigCalenderCellState
              .SelectableIndividualCellFromCustomer)
      ) {
        var __CellState =
          this.state.cellstate ==
          window.Enums.EBigCalenderCellState.SelectedFromCustomer
            ? window.Enums.EBigCalenderCellState
                .SelectableIndividualCellFromCustomer
            : window.Enums.EBigCalenderCellState.SelectedFromCustomer;

        this.setState(
          {
            cellstate: __CellState,
          },
          () => {
            this.props.owner.HandleRefreshReservationList();
          }
        );

        if (this.Constrained != null) {
          for (var i = 0; i < this.Constrained.ItemList.length; i++) {
            this.Constrained.ItemList[i].setState({
              cellstate: __CellState,
            });
          }
        }
      }
    },
    HandleCellOnClick_CustomerAvailableBookSelection_Class: function (_Event) {
      if (
        !this.props.locked &&
        this.state.hover &&
        (this.state.cellstate ==
          window.Enums.EBigCalenderCellState.SelectedFromCustomer ||
          this.state.cellstate ==
            window.Enums.EBigCalenderCellState.SelectableGroupCellFromCustomer)
      ) {
        var __CellState =
          this.state.cellstate ==
          window.Enums.EBigCalenderCellState.SelectedFromCustomer
            ? window.Enums.EBigCalenderCellState.SelectableGroupCellFromCustomer
            : window.Enums.EBigCalenderCellState.SelectedFromCustomer;
        this.setState(
          {
            cellstate: __CellState,
          },
          () => {
            this.props.owner.HandleRefreshReservationList();
          }
        );

        if (this.Constrained != null) {
          for (var i = 0; i < this.Constrained.ItemList.length; i++) {
            this.Constrained.ItemList[i].setState({
              cellstate: __CellState,
            });
          }
        }
      }
    },
    HandleCellOnClick_SellerBookedScheduler: function (_Event) {
      if (this.AvailableTimeItemList.length > 0) {
        var __StartCell = this.props.owner.HandleGetLessonStartCell(this);
        window.App.BigCalender_CellModal_SellerBookedScheduler.HandleClickOpen({
          CellItem: __StartCell,
        });
      }
    },
    HandleCellOnClick_CustomerBookedScheduler: function (_Event) {
      if (this.AvailableTimeItemList.length > 0) {
        var __StartCell = this.props.owner.HandleGetLessonStartCell(this);
        window.App.BigCalender_CellModal_CustomerBookedScheduler.HandleClickOpen(
          { CellItem: __StartCell }
        );
      }
    },
    HandleCellOnClick: function (_Event) {
      if (this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection) {
        this.HandleCellOnClick_ClassTimeSelection(_Event);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection
      ) {
        this.HandleCellOnClick_AvailableTimeSelection(_Event);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        this.HandleCellOnClick_MiniAvailableTimeShow(_Event);
      } else if (
        this.props.type ==
        window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Individual
      ) {
        this.HandleCellOnClick_CustomerAvailableBookSelection_Individual(
          _Event
        );
      } else if (
        this.props.type ==
        window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        this.HandleCellOnClick_CustomerAvailableBookSelection_Class(_Event);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        this.HandleCellOnClick_SellerBookedScheduler(_Event);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        this.HandleCellOnClick_CustomerBookedScheduler(_Event);
      } else {
        if (!this.props.locked && this.state.hover) {
          if (
            this.state.cellstate !=
              window.Enums.EBigCalenderCellState.BookedByYou &&
            this.state.cellstate !=
              window.Enums.EBigCalenderCellState.BookedByOther
          ) {
            this.setState({
              cellstate:
                this.state.cellstate ==
                window.Enums.EBigCalenderCellState.NotSelected
                  ? window.Enums.EBigCalenderCellState.SelectedFromSeller
                  : window.Enums.EBigCalenderCellState.NotSelected,
            });
          }
        }
      }
    },
    HandleGetMinuteToHourAndMinute: function (_Minutes) {
      let _Hours = 0;
      let _Days = 0;
      let _RestMinutes = 0;
      const _OnedayMinutes = 1440; //24*60

      if (_Minutes < 60) {
        return `${_Minutes} Minutes`;
      } else if (_Minutes > 60 && _Minutes < _OnedayMinutes) {
        _Hours = Math.floor(_Minutes / 60);
        _RestMinutes = _Minutes % 60;
        return `${_Hours.toString().padStart(2, "0")}:${_RestMinutes
          .toString()
          .padStart(2, "0")}`;
      } else {
        _Days = Math.floor(_Minutes / 60 / 24);
        _RestMinutes = _Minutes % _OnedayMinutes;
        _Hours = Math.floor(_RestMinutes / 60);
        _RestMinutes = _RestMinutes % 60;
        return `${_Hours.toString().padStart(2, "0")}:${_RestMinutes
          .toString()
          .padStart(2, "0")}`;
        //return `${days} Days ${hours} Hours ${restMinutes} Minutes`
      }
    },

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////
    /////////////////  Hücre Tooltip Gösterim ///////////////////////////
    //////////////////////////////////////////////////////////////////
    HandleGetTooltip_MiniAvailableTimeShow: function (_Item) {
      const { classes } = this.props;

      if (this.AvailableTimeItemList.length > 0) {
        if (this.props.owner.props.isGroupLesson) {
          var __FreeTimeCount = 0;
          var __BussyTimeCount = 0;
          var __ToolTip = (
            <h6
              style={{
                color: DefaultTheme.palette.secondary.contrastText,
                marginTop: "10px",
              }}
            >
              {this.AvailableTimeItemList.map((_Item, _Index) => {
                return (
                  <div>
                    {this.state.Language.BookedClassTimeBlock.format(
                      _Item.BookedCount,
                      _Item.MaxBookingCount
                    )}
                  </div>
                );
              })}
            </h6>
          );

          return (
            <Tooltip placement="right-start" title={__ToolTip} arrow>
              {_Item}
            </Tooltip>
          );
        } else {
          var __FreeTimeCount = 0;
          var __BussyTimeCount = 0;

          for (var i = 0; i < this.AvailableTimeItemList.length; i++) {
            if (this.AvailableTimeItemList[i].IsBooked) {
              __BussyTimeCount++;
            } else {
              __FreeTimeCount++;
            }
          }

          return (
            <Tooltip
              placement="right-start"
              title={
                <h6
                  style={{
                    color: DefaultTheme.palette.secondary.contrastText,
                    marginTop: "10px",
                  }}
                >
                  {this.state.Language.FreeTimeBlock.format(__FreeTimeCount)}
                  <br />
                  {this.state.Language.BookedTimeBlock.format(__BussyTimeCount)}
                </h6>
              }
              arrow
            >
              {_Item}
            </Tooltip>
          );
        }
      } else {
        return _Item;
      }
    },
    HandleTooltip_CustomerAvailableBookSelection: function (_Item) {
      const { classes } = this.props;

      var __StartTime =
        this.props.blockstarthour.toString().padStart(2, "0") +
        ":" +
        this.props.blockstartminute.toString().padStart(2, "0");

      var __TotalMinute =
        this.props.blockstarthour * 60 + this.props.blockstartminute;
      __TotalMinute =
        __TotalMinute + this.props.mergedcell * this.props.stepminute;
      var __EndTime = this.HandleGetMinuteToHourAndMinute(__TotalMinute);

      var __DayNamePart1 = moment(this.props.daydate)
        .locale(this.state.Language.LanguageCode)
        .format("ddd, MMM D");

      return (
        <Tooltip
          placement="right-start"
          title={
            <h6
              style={{
                color: DefaultTheme.palette.secondary.contrastText,
                marginTop: "10px",
              }}
            >
              {__DayNamePart1}
              <br />
              {__StartTime + " - " + __EndTime}
            </h6>
          }
          arrow
        >
          {_Item}
        </Tooltip>
      );
    },
    HandleTooltip_AvailableTimeSelection: function (_Item) {
      const { classes } = this.props;

      var __StartTime =
        this.props.blockstarthour.toString().padStart(2, "0") +
        ":" +
        this.props.blockstartminute.toString().padStart(2, "0");
      var __EndTime =
        this.props.blockendhour.toString().padStart(2, "0") +
        ":" +
        this.props.blockendminute.toString().padStart(2, "0");

      var __DayNamePart1 = moment(this.props.daydate)
        .locale(this.state.Language.LanguageCode)
        .format("dddd");

      return (
        <Tooltip
          placement="right-start"
          title={
            <h6
              style={{
                color: DefaultTheme.palette.secondary.contrastText,
                marginTop: "10px",
              }}
            >
              {__DayNamePart1}
              <br />
              {__StartTime + " - " + __EndTime}
            </h6>
          }
          arrow
        >
          {_Item}
        </Tooltip>
      );
    },
    HandleTooltip_SellerBookedScheduler: function (_Item) {
      const { classes } = this.props;

      var __StartCell = this.props.owner.HandleGetLessonStartCell(this);

      if (
        this.AvailableTimeItemList.length > 0 &&
        __StartCell.AvailableTimeItemList.length > 0
      ) {
        var __StartTime =
          __StartCell.props.blockstarthour.toString().padStart(2, "0") +
          ":" +
          __StartCell.props.blockstartminute.toString().padStart(2, "0");

        var __StartDate = new Date(
          2020,
          0,
          1,
          __StartCell.props.blockstarthour,
          __StartCell.props.blockstartminute,
          0,
          0
        );
        var __EndDate = moment(__StartDate)
          .add(__StartCell.AvailableTimeItemList[0].LessonTotalMinute, "m")
          .toDate();

        var __EndHour = __EndDate.getHours();
        var __EndMinute = __EndDate.getMinutes();

        var __EndTime =
          __EndHour.toString().padStart(2, "0") +
          ":" +
          __EndMinute.toString().padStart(2, "0");

        var __DayNamePart1 = moment(__StartCell.props.daydate)
          .locale(this.state.Language.LanguageCode)
          .format("MMMM D");
        var __DayNamePart2 = moment(__StartCell.props.daydate)
          .locale(this.state.Language.LanguageCode)
          .format("dddd");

        if (
          this.AvailableTimeItemList[0].LessonType ==
          window.Enums.ELessonType.Individual.ID
        ) {
          return (
            <Tooltip
              placement="right-start"
              title={
                <h6
                  style={{
                    color: DefaultTheme.palette.secondary.contrastText,
                    marginTop: "10px",
                  }}
                >
                  {__DayNamePart1}
                  <br />
                  {__DayNamePart2 + " , " + __StartTime + " - " + __EndTime}
                  <br />
                  <Divider
                    variant="fullWidth"
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      backgroundColor:
                        DefaultTheme.palette.secondary.contrastText,
                      opacity: 0.5,
                    }}
                  />
                  {this.AvailableTimeItemList[0].UserName +
                    " " +
                    this.AvailableTimeItemList[0].UserSurname}
                </h6>
              }
              arrow
            >
              {_Item}
            </Tooltip>
          );
        } else {
          return (
            <Tooltip
              placement="right-start"
              title={
                <h6
                  style={{
                    color: DefaultTheme.palette.secondary.contrastText,
                    marginTop: "10px",
                  }}
                >
                  <div>
                    {__DayNamePart1}
                    <br />
                    {__DayNamePart2 + " , " + __StartTime + " - " + __EndTime}
                  </div>
                  <Divider
                    variant="fullWidth"
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      backgroundColor:
                        DefaultTheme.palette.secondary.contrastText,
                      opacity: 0.5,
                    }}
                  />
                  <div>
                    {this.state.Language.BookedClassTimeBlock.format(
                      this.AvailableTimeItemList[0].BookedCount,
                      this.AvailableTimeItemList[0].MaxBookingCount
                    )}
                    <Divider
                      variant="fullWidth"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        backgroundColor:
                          DefaultTheme.palette.secondary.contrastText,
                        opacity: 0.5,
                      }}
                    />
                    {this.AvailableTimeItemList.map((_MapItem, _Index) => {
                      return (
                        <div>
                          {_MapItem.UserName + " " + _MapItem.UserSurname}
                          <br />
                        </div>
                      );
                    })}
                  </div>
                </h6>
              }
              arrow
            >
              {_Item}
            </Tooltip>
          );
        }
      }
      return _Item;
    },
    HandleTooltip_CustomerBookedScheduler: function (_Item) {
      const { classes } = this.props;

      var __StartCell = this.props.owner.HandleGetLessonStartCell(this);

      if (
        this.AvailableTimeItemList.length > 0 &&
        __StartCell.AvailableTimeItemList.length > 0
      ) {
        var __StartTime =
          __StartCell.props.blockstarthour.toString().padStart(2, "0") +
          ":" +
          __StartCell.props.blockstartminute.toString().padStart(2, "0");

        var __StartDate = new Date(
          2020,
          0,
          1,
          __StartCell.props.blockstarthour,
          __StartCell.props.blockstartminute,
          0,
          0
        );
        var __EndDate = moment(__StartDate)
          .add(__StartCell.AvailableTimeItemList[0].LessonTotalMinute, "m")
          .toDate();

        var __EndHour = __EndDate.getHours();
        var __EndMinute = __EndDate.getMinutes();

        var __EndTime =
          __EndHour.toString().padStart(2, "0") +
          ":" +
          __EndMinute.toString().padStart(2, "0");

        var __DayNamePart1 = moment(__StartCell.props.daydate)
          .locale(this.state.Language.LanguageCode)
          .format("MMMM D");
        var __DayNamePart2 = moment(__StartCell.props.daydate)
          .locale(this.state.Language.LanguageCode)
          .format("dddd");

        if (
          this.AvailableTimeItemList[0].LessonType ==
          window.Enums.ELessonType.Individual.ID
        ) {
          return (
            <Tooltip
              placement="right-start"
              title={
                <h6
                  style={{
                    color: DefaultTheme.palette.secondary.contrastText,
                    marginTop: "10px",
                  }}
                >
                  {__DayNamePart1}
                  <br />
                  {__DayNamePart2 + " , " + __StartTime + " - " + __EndTime}
                  <br />
                  <Divider
                    variant="fullWidth"
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      backgroundColor:
                        DefaultTheme.palette.secondary.contrastText,
                      opacity: 0.5,
                    }}
                  />
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item style={{ marginRight: "15px" }}>
                      <TAvatar
                        src={
                          window.App.GlobalParams.SiteUrl +"/assets/img/profileimages/" +
                          this.AvailableTimeItemList[0].TeacherProfileImage
                        }
                        className={classNames(classes.avatar, "img-avatar")}
                      />
                    </Grid>
                    <Grid item style={{ marginRight: "15px" }}>
                      {this.state.Language.Teacher}
                      <br />
                      {this.AvailableTimeItemList[0].UserName +
                        " " +
                        this.AvailableTimeItemList[0].UserSurname}
                    </Grid>
                  </Grid>
                </h6>
              }
              arrow
            >
              {_Item}
            </Tooltip>
          );
        } else {
          return (
            <Tooltip
              placement="right-start"
              title={
                <h6
                  style={{
                    color: DefaultTheme.palette.secondary.contrastText,
                    marginTop: "10px",
                  }}
                >
                  <div>
                    {__DayNamePart1}
                    <br />
                    {__DayNamePart2 + " , " + __StartTime + " - " + __EndTime}
                  </div>
                  <Divider
                    variant="fullWidth"
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                      backgroundColor:
                        DefaultTheme.palette.secondary.contrastText,
                      opacity: 0.5,
                    }}
                  />
                  <div>
                    {this.state.Language.BookedClassTimeBlock.format(
                      this.AvailableTimeItemList[0].BookedCount,
                      this.AvailableTimeItemList[0].MaxBookingCount
                    )}
                    <Divider
                      variant="fullWidth"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        backgroundColor:
                          DefaultTheme.palette.secondary.contrastText,
                        opacity: 0.5,
                      }}
                    />
                    <div>
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item style={{ marginRight: "15px" }}>
                          <TAvatar
                            src={
                              window.App.GlobalParams.SiteUrl +"/assets/img/profileimages/" +
                              this.AvailableTimeItemList[0].TeacherProfileImage
                            }
                            className={classNames(classes.avatar, "img-avatar")}
                          />
                        </Grid>
                        <Grid item style={{ marginRight: "15px" }}>
                          {this.state.Language.Teacher}
                          <br />
                          {this.AvailableTimeItemList[0].UserName +
                            " " +
                            this.AvailableTimeItemList[0].UserSurname}
                        </Grid>
                      </Grid>

                      <br />
                    </div>
                  </div>
                </h6>
              }
              arrow
            >
              {_Item}
            </Tooltip>
          );
        }
      }
      return _Item;
    },
    HandleWrapTooltip: function (_Item) {
      var __This = this;
      if (
        this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow
      ) {
        return this.HandleGetTooltip_MiniAvailableTimeShow(_Item);
      } else if (
        this.props.type ==
          window.Enums.EBigCalenderType
            .CustomerAvailableBookSelection_Individual ||
        this.props.type ==
          window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class
      ) {
        return this.HandleTooltip_CustomerAvailableBookSelection(_Item);
      } else if (
        this.props.type ==
          window.Enums.EBigCalenderType.AvailableTimeSelection ||
        this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection
      ) {
        return this.HandleTooltip_AvailableTimeSelection(_Item);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        return this.HandleTooltip_SellerBookedScheduler(_Item);
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        return this.HandleTooltip_CustomerBookedScheduler(_Item);
      } else {
        return (
          <Tooltip
            placement="right-start"
            title={
              <h6
                style={{
                  color: DefaultTheme.palette.secondary.contrastText,
                  marginTop: "10px",
                }}
              >
                {"Test"}
              </h6>
            }
            arrow
          >
            {_Item}
          </Tooltip>
        );
      }
    },

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////////
    /////////////////  Hücre İçi Gösterim ///////////////////////////
    //////////////////////////////////////////////////////////////////
    HandleGetCellInnerValue_SellerBookedScheduler: function () {
      const { classes } = this.props;
      if (this.HandleIsLessonStartCell()) {
        if (
          this.AvailableTimeItemList.length > 0 &&
          this.AvailableTimeItemList[0].LessonType ==
            window.Enums.ELessonType.Individual.ID
        ) {
          return (
            <div style={{ color: DefaultTheme.palette.secondary.contrastText }}>
              {this.state.Language[this.AvailableTimeItemList[0].LessonName]}
            </div>
          );
        } else if (
          this.AvailableTimeItemList.length > 0 &&
          this.AvailableTimeItemList[0].LessonType ==
            window.Enums.ELessonType.Class.ID
        ) {
          return (
            <div>
              <LinearProgress
                variant="determinate"
                color="secondary"
                value={
                  (this.AvailableTimeItemList[0].BookedCount /
                    this.AvailableTimeItemList[0].MaxBookingCount) *
                  100
                }
              />
              <div className={classNames(classes.groupCell_ForBookedViewInner)}>
                {this.state.Language[this.AvailableTimeItemList[0].LessonName]}
              </div>
            </div>
          );
        }
      }
      return null;
    },
    HandleGetCellInnerValue_CustomerBookedScheduler: function () {
      const { classes } = this.props;
      if (this.HandleIsLessonStartCell()) {
        if (
          this.AvailableTimeItemList.length > 0 &&
          this.AvailableTimeItemList[0].LessonType ==
            window.Enums.ELessonType.Individual.ID
        ) {
          return (
            <div style={{ color: DefaultTheme.palette.secondary.contrastText }}>
              {this.state.Language[this.AvailableTimeItemList[0].LessonName]}
            </div>
          );
        } else if (
          this.AvailableTimeItemList.length > 0 &&
          this.AvailableTimeItemList[0].LessonType ==
            window.Enums.ELessonType.Class.ID
        ) {
          return (
            <div>
              <LinearProgress
                variant="determinate"
                color="secondary"
                value={
                  (this.AvailableTimeItemList[0].BookedCount /
                    this.AvailableTimeItemList[0].MaxBookingCount) *
                  100
                }
              />
              <div className={classNames(classes.groupCell_ForBookedViewInner)}>
                {this.state.Language[this.AvailableTimeItemList[0].LessonName]}
              </div>
            </div>
          );
        }
      }
      return null;
    },
    HandleGetCellInnerValue: function () {
      const { classes } = this.props;

      if (
        this.props.type == window.Enums.EBigCalenderType.SellerBookedScheduler
      ) {
        return this.HandleGetCellInnerValue_SellerBookedScheduler();
      } else if (
        this.props.type == window.Enums.EBigCalenderType.CustomerBookedScheduler
      ) {
        return this.HandleGetCellInnerValue_CustomerBookedScheduler();
      }
      return null;
    },

    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////
    render: function () {
      var __This = this;
      const { classes } = this.props;
      var __DayList = moment().day(0);

      var __tempday = moment(this.props.daydate)
        .locale(this.state.Language.LanguageCode)
        .format("ddd, MMM Do");

      var __DayNumber = this.props.daydate.getDay();
      var __DayName = moment().isoWeekday(__DayNumber);
      var __DayOfMounth = this.props.daydate.getDate().toString();

      return this.HandleWrapTooltip(
        <div
          className={classNames(
            this.HandleGetBoxProps(),
            this.HandleGetBoxState()
          )}
          onMouseEnter={this.HandleOnMouseEnterHandler}
          onMouseLeave={this.HandleOnMouseLeave}
          onClick={this.HandleCellOnClick}
        >
          {this.HandleGetCellInnerValue()}
        </div>
      );
    },
  },
  {}
);

export default withStyles(BigCalendarStyles)(TBigCalenderItem);
